import { Link } from "react-router-dom";
import { channels } from "@/mocks/categories";
import { siteName, siteSlogan } from "@/hooks/useSeo";

export default function Footer() {
  return (
    <footer className="w-full border-t border-background-200 bg-accent-100">
      <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-8 px-4 py-12 sm:grid-cols-2 md:px-6 lg:grid-cols-4">
        <div className="lg:col-span-1">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-flashlight-fill text-lg"></i>
            </span>
            <span className="font-display text-lg font-bold text-foreground-950">{siteName}</span>
          </div>
          <p className="mt-4 text-sm leading-6 text-foreground-600">
            {siteSlogan}。聚焦新晋网红黑料、小艺人黑历史、练习生爆料与新人演员翻车现场，点开挖掘新面孔的隐藏故事，看清人设背后的真相。
          </p>
          <p className="mt-4 text-xs leading-5 text-foreground-500">
            本站内容均基于公开信息与用户投稿整理，旨在理性讨论行业现象，请勿对号入座，也请勿据此进行人身攻击。
          </p>
        </div>

        <div>
          <h4 className="font-label text-sm font-semibold text-foreground-950">栏目导航</h4>
          <ul className="mt-4 space-y-2.5">
            {channels.map((c) => (
              <li key={c.key}>
                <Link
                  to={`/channels?category=${c.key}`}
                  className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                >
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-label text-sm font-semibold text-foreground-950">快速入口</h4>
          <ul className="mt-4 space-y-2.5">
            {[
              { to: "/", label: "首页热点" },
              { to: "/channels", label: "全部资讯" },
              { to: "/about", label: "关于我们" },
              { to: "/faq", label: "常见问题" },
              { to: "/contact", label: "投稿与联系" },
            ].map((l) => (
              <li key={l.to + l.label}>
                <Link to={l.to} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-label text-sm font-semibold text-foreground-950">订阅站内动态</h4>
          <p className="mt-4 text-sm leading-6 text-foreground-600">
            关注编辑部最新盘点与热点追踪，第一时间掌握娱乐场上的新瓜速递。
          </p>
          <p className="mt-4 text-sm text-foreground-600">
            <span className="mr-2 inline-flex h-6 w-6 items-center justify-center rounded-full bg-accent-500 text-background-50">
              <i className="ri-mail-line text-xs"></i>
            </span>
            dailygossip@example.com
          </p>
          <p className="mt-2 text-sm text-foreground-600">
            <span className="mr-2 inline-flex h-6 w-6 items-center justify-center rounded-full bg-accent-500 text-background-50">
              <i className="ri-wechat-line text-xs"></i>
            </span>
            公众号：每日新瓜
          </p>
        </div>
      </div>

      <div className="border-t border-accent-200/70">
        <div className="mx-auto flex max-w-[1200px] flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-foreground-500 sm:flex-row md:px-6">
          <p>© 2026 {siteName} 版权所有 · 理性吃瓜，尊重事实</p>
          <p className="flex items-center gap-1">
            本网站为虚构示例内容 <i className="ri-emotion-happy-line"></i>
          </p>
        </div>
      </div>
    </footer>
  );
}